module.exports = __webpack_public_path__ + "img/rrze.12ab7f6d.svg";